import type { ElementType } from 'react';
import { LayoutDashboard, Wrench, ClipboardList, CloudSun, Settings, FormInput, Layers } from 'lucide-react';
import { ROUTES } from '../../../config/links';

export interface NavItem {
  name: string;
  href: string;
  icon: ElementType;
  /** Secondary line under the label. */
  description?: string;
  /** Path prefixes that mark this item active (defaults to href). */
  activePaths?: string[];
}

/** Primary topbar / mobile-drawer links (any authenticated user). */
export const mainNav: NavItem[] = [
  { name: 'Dashboard', href: ROUTES.ROOT, icon: LayoutDashboard, activePaths: [ROUTES.ROOT] },
  {
    name: 'Calibrations',
    href: ROUTES.CALIBRATIONS,
    icon: Wrench,
    activePaths: [ROUTES.CALIBRATIONS],
  },
];

/** Manage dropdown children — UI + routes are admin-only. */
export const manageNav: NavItem[] = [
  {
    name: 'Form Builder',
    href: ROUTES.FORM_BUILDER,
    icon: FormInput,
    description: 'Create and manage forms',
    activePaths: [ROUTES.FORM_BUILDER],
  },
  {
    name: 'Dynamic Fields',
    href: ROUTES.DYNAMIC_FIELDS,
    icon: Layers,
    description: 'Define the fields forms can select per sensor type',
    activePaths: [ROUTES.DYNAMIC_FIELDS],
  },
  {
    name: 'Acceptance Criteria',
    href: ROUTES.MANAGE_ACCEPTANCE_CRITERIA,
    icon: ClipboardList,
    description: 'Manage acceptance criteria',
    activePaths: [ROUTES.MANAGE_ACCEPTANCE_CRITERIA],
  },
  {
    name: 'Environmental Data',
    href: ROUTES.MANAGE_DAILY_ENV_DATA,
    icon: CloudSun,
    description: 'Daily environmental readings',
    activePaths: [ROUTES.MANAGE_DAILY_ENV_DATA],
  },
];

export const manageParent = {
  name: 'Manage',
  icon: Settings,
  activePaths: [ROUTES.MANAGE],
} as const;

export function isNavItemActive(pathname: string, item: Pick<NavItem, 'href' | 'activePaths'>): boolean {
  const paths = item.activePaths ?? [item.href];
  return paths.some((p) => {
    if (p === ROUTES.ROOT) return pathname === ROUTES.ROOT;
    return pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(p);
  });
}

export function isManageActive(pathname: string): boolean {
  return pathname.startsWith(ROUTES.MANAGE);
}
